// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PDLVehiclePopover_modalBody__efiCy {
    padding: 0 20px 18px;
    font-family: inherit;
    color: #212529;
}

/* Header */

.PDLVehiclePopover_detailsHeader__FM428 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 2px;
    border-bottom: 1px solid #dee2e6;
}

.PDLVehiclePopover_detailsTitle__blUJA {
    font-size: 15px;
    font-weight: 700;
    color: #212529;
}

.PDLVehiclePopover_detailsSubtitle__cVJs3 {
    margin-top: 3px;
    font-size: 12px;
    color: #6c757d;
}

.PDLVehiclePopover_separator__VWgud {
    margin: 0 6px;
    color: #adb5bd;
}

/* Download Button */

.PDLVehiclePopover_downloadButton__AXZ1a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    height: 25px;
    padding: 5px;
    border: 1px solid var(--primary-blue-theme-color);
    border-radius: 5px;
    background-color: var(--primary-blue-theme-color);
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s ease;
}

.PDLVehiclePopover_downloadButton__AXZ1a:hover {
    background-color: #426b97;
    border-color: #426b97;
}

.PDLVehiclePopover_downloadButton__AXZ1a:disabled {
    opacity: 0.55;
    cursor: not-allowed;
}

.PDLVehiclePopover_downloadIcon__GWMaN {
    font-size: 16px;
    line-height: 1;
    font-weight: 700;
}

/* Filter */

.PDLVehiclePopover_filterContainer__wnqGY {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    padding: 14px 2px;
    background-color: #fff;
}

.PDLVehiclePopover_filterTitle__t4rpU {
    font-size: 12px;
    font-weight: 600;
    color: #495057;
    white-space: nowrap;
}

.PDLVehiclePopover_selectWrapper__4IHQW {
    width: 260px;
}

/* Table */

.PDLVehiclePopover_tableContainer__InjAm {
    border: 1px solid #dee2e6;
    border-radius: 6px;
    overflow: hidden;
    min-height: 200px;
    max-height: 300px;
    overflow-y: scroll;
    overflow-x: scroll;
}

.PDLVehiclePopover_vehicleTable__KG0I7 {
    width: 100%;
    margin: 0;
    font-size: 12px;
    border-color: #dee2e6;
}

.PDLVehiclePopover_vehicleTable__KG0I7 thead th {
    background-color: var(--primary-blue-theme-color);
    color: #fff;
    border-color: var(--primary-blue-theme-color);
    padding: 10px 12px;
    font-size: 12px;
    font-weight: 600;
    text-align: left;
    vertical-align: middle;
    white-space: nowrap;
}

.PDLVehiclePopover_vehicleTable__KG0I7 tbody td {
    padding: 9px 12px;
    font-size: 12px;
    font-weight: 400;
    color: #343a40;
    border-color: #dee2e6;
    vertical-align: middle;
    background-color: #fff;
}

.PDLVehiclePopover_vehicleTable__KG0I7 tbody tr:hover td {
    background-color: #f5f8fb;
}

.PDLVehiclePopover_vehicleTable__KG0I7 tbody tr:last-child td {
    /* border-bottom: 0; */
}

/* Registration Number */

.PDLVehiclePopover_regNo__8sfFT {
    font-weight: 600 !important;
    color: #212529 !important;
}

/* Ageing Badge */

.PDLVehiclePopover_ageingBadge__S0qpo {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 30px;
    padding: 3px 8px;
    border-radius: 12px;
    background-color: #e8f0f7;
    color: var(--primary-blue-theme-color);
    font-size: 11px;
    font-weight: 600;
}

/* Device Details */

.PDLVehiclePopover_deviceStatus__LBXXy {
    color: #495057;
    font-size: 12px;
}

/* Empty State */

.PDLVehiclePopover_emptyState__AYNpJ {
    height: 100px;
    text-align: center !important;
    vertical-align: middle !important;
    color: #6c757d !important;
    font-size: 12px !important;
}

/* Footer */

.PDLVehiclePopover_tableFooter__E5ixj {
    padding: 9px 2px 0;
    color: #6c757d;
    font-size: 11px;
}

.PDLVehiclePopover_tableFooter__E5ixj strong {
    color: #343a40;
    font-weight: 600;
}

/* Responsive */

@media (max-width: 768px) {
    .PDLVehiclePopover_modalBody__efiCy {
        padding: 0 12px 14px;
    }

    .PDLVehiclePopover_detailsHeader__FM428 {
        align-items: flex-start;
        gap: 10px;
    }

    .PDLVehiclePopover_downloadButton__AXZ1a {
        padding: 0 10px;
    }

    .PDLVehiclePopover_filterContainer__wnqGY {
        align-items: flex-start;
        flex-direction: column;
        gap: 8px;
    }

    .PDLVehiclePopover_selectWrapper__4IHQW {
        width: 100%;
    }
}




`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/SmartCIty/PDL/LostPDLTable/PDLVehiclePopover.module.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;AAClB;;AAEA,WAAW;;AAEX;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA,oBAAoB;;AAEpB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,iDAAiD;IACjD,kBAAkB;IAClB,iDAAiD;IACjD,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA,WAAW;;AAEX;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA,UAAU;;AAEV;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,SAAS;IACT,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,iDAAiD;IACjD,WAAW;IACX,6CAA6C;IAC7C,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,wBAAwB;;AAExB;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA,iBAAiB;;AAEjB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,sCAAsC;IACtC,eAAe;IACf,gBAAgB;AACpB;;AAEA,mBAAmB;;AAEnB;IACI,cAAc;IACd,eAAe;AACnB;;AAEA,gBAAgB;;AAEhB;IACI,aAAa;IACb,6BAA6B;IAC7B,iCAAiC;IACjC,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA,WAAW;;AAEX;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA,eAAe;;AAEf;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".modalBody {\n    padding: 0 20px 18px;\n    font-family: inherit;\n    color: #212529;\n}\n\n/* Header */\n\n.detailsHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 14px 2px;\n    border-bottom: 1px solid #dee2e6;\n}\n\n.detailsTitle {\n    font-size: 15px;\n    font-weight: 700;\n    color: #212529;\n}\n\n.detailsSubtitle {\n    margin-top: 3px;\n    font-size: 12px;\n    color: #6c757d;\n}\n\n.separator {\n    margin: 0 6px;\n    color: #adb5bd;\n}\n\n/* Download Button */\n\n.downloadButton {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 7px;\n    height: 25px;\n    padding: 5px;\n    border: 1px solid var(--primary-blue-theme-color);\n    border-radius: 5px;\n    background-color: var(--primary-blue-theme-color);\n    color: #fff;\n    font-size: 12px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.downloadButton:hover {\n    background-color: #426b97;\n    border-color: #426b97;\n}\n\n.downloadButton:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n}\n\n.downloadIcon {\n    font-size: 16px;\n    line-height: 1;\n    font-weight: 700;\n}\n\n/* Filter */\n\n.filterContainer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 15px;\n    padding: 14px 2px;\n    background-color: #fff;\n}\n\n.filterTitle {\n    font-size: 12px;\n    font-weight: 600;\n    color: #495057;\n    white-space: nowrap;\n}\n\n.selectWrapper {\n    width: 260px;\n}\n\n/* Table */\n\n.tableContainer {\n    border: 1px solid #dee2e6;\n    border-radius: 6px;\n    overflow: hidden;\n    min-height: 200px;\n    max-height: 300px;\n    overflow-y: scroll;\n    overflow-x: scroll;\n}\n\n.vehicleTable {\n    width: 100%;\n    margin: 0;\n    font-size: 12px;\n    border-color: #dee2e6;\n}\n\n.vehicleTable thead th {\n    background-color: var(--primary-blue-theme-color);\n    color: #fff;\n    border-color: var(--primary-blue-theme-color);\n    padding: 10px 12px;\n    font-size: 12px;\n    font-weight: 600;\n    text-align: left;\n    vertical-align: middle;\n    white-space: nowrap;\n}\n\n.vehicleTable tbody td {\n    padding: 9px 12px;\n    font-size: 12px;\n    font-weight: 400;\n    color: #343a40;\n    border-color: #dee2e6;\n    vertical-align: middle;\n    background-color: #fff;\n}\n\n.vehicleTable tbody tr:hover td {\n    background-color: #f5f8fb;\n}\n\n.vehicleTable tbody tr:last-child td {\n    /* border-bottom: 0; */\n}\n\n/* Registration Number */\n\n.regNo {\n    font-weight: 600 !important;\n    color: #212529 !important;\n}\n\n/* Ageing Badge */\n\n.ageingBadge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 30px;\n    padding: 3px 8px;\n    border-radius: 12px;\n    background-color: #e8f0f7;\n    color: var(--primary-blue-theme-color);\n    font-size: 11px;\n    font-weight: 600;\n}\n\n/* Device Details */\n\n.deviceStatus {\n    color: #495057;\n    font-size: 12px;\n}\n\n/* Empty State */\n\n.emptyState {\n    height: 100px;\n    text-align: center !important;\n    vertical-align: middle !important;\n    color: #6c757d !important;\n    font-size: 12px !important;\n}\n\n/* Footer */\n\n.tableFooter {\n    padding: 9px 2px 0;\n    color: #6c757d;\n    font-size: 11px;\n}\n\n.tableFooter strong {\n    color: #343a40;\n    font-weight: 600;\n}\n\n/* Responsive */\n\n@media (max-width: 768px) {\n    .modalBody {\n        padding: 0 12px 14px;\n    }\n\n    .detailsHeader {\n        align-items: flex-start;\n        gap: 10px;\n    }\n\n    .downloadButton {\n        padding: 0 10px;\n    }\n\n    .filterContainer {\n        align-items: flex-start;\n        flex-direction: column;\n        gap: 8px;\n    }\n\n    .selectWrapper {\n        width: 100%;\n    }\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalBody": `PDLVehiclePopover_modalBody__efiCy`,
	"detailsHeader": `PDLVehiclePopover_detailsHeader__FM428`,
	"detailsTitle": `PDLVehiclePopover_detailsTitle__blUJA`,
	"detailsSubtitle": `PDLVehiclePopover_detailsSubtitle__cVJs3`,
	"separator": `PDLVehiclePopover_separator__VWgud`,
	"downloadButton": `PDLVehiclePopover_downloadButton__AXZ1a`,
	"downloadIcon": `PDLVehiclePopover_downloadIcon__GWMaN`,
	"filterContainer": `PDLVehiclePopover_filterContainer__wnqGY`,
	"filterTitle": `PDLVehiclePopover_filterTitle__t4rpU`,
	"selectWrapper": `PDLVehiclePopover_selectWrapper__4IHQW`,
	"tableContainer": `PDLVehiclePopover_tableContainer__InjAm`,
	"vehicleTable": `PDLVehiclePopover_vehicleTable__KG0I7`,
	"regNo": `PDLVehiclePopover_regNo__8sfFT`,
	"ageingBadge": `PDLVehiclePopover_ageingBadge__S0qpo`,
	"deviceStatus": `PDLVehiclePopover_deviceStatus__LBXXy`,
	"emptyState": `PDLVehiclePopover_emptyState__AYNpJ`,
	"tableFooter": `PDLVehiclePopover_tableFooter__E5ixj`
};
export default ___CSS_LOADER_EXPORT___;
